import { LucideCode2 } from 'lucide-react';

import { cn } from '../../../lib/stylingUtils';
import { Col, Row } from '../../ui';

type JsonViewerProps = {
  data: string;
  title?: string;
  className?: string;
};

const formatJson = (jsonString: string) => {
  try {
    const parsed = JSON.parse(jsonString);
    return JSON.stringify(parsed, null, 2);
  } catch {
    return jsonString;
  }
};

export const JsonViewer = ({ data, title, className }: JsonViewerProps) => (
  <Col
    className={cn(
      '@JsonViewer',
      'flex-1 rounded-md border border-neutral/10 bg-white',
      className,
    )}
  >
    {title && (
      <Row
        className="items-center gap-2 border-b border-neutral/10 p-3"
        gap2
        yCenter
      >
        <LucideCode2 size={14} className="text-neutral/50" />
        <span className="text-sm font-medium text-neutral/80">{title}</span>
      </Row>
    )}
    <pre className="flex-1 overflow-auto p-3 font-mono text-xs">
      {formatJson(data)}
    </pre>
  </Col>
);
